<template>
<div class="mTalentIndexContent">
    <div class="top_box">
        <h4>高薪优质金融资本职位任你选</h4>
        <p>快速对接，让你步入职场快车道</p>
        <div class="swiper_box">
            <van-swipe class="my-swipe" style="height: 0.48rem;" :autoplay="3000" vertical :touchable="false">
                <van-swipe-item v-for="(item, index) in indexDatas.rolllist" :key="index">
                    <p>{{item.customername}}</p>
                    <p>确认Offer</p>
                    <p>{{item.companydisplayname}}</p>
                    <p>年薪{{item.factsalary}}万</p>
                    <p>{{item.datetime}}</p>
                </van-swipe-item>
            </van-swipe>
        </div>
    </div>
    <div class="job_class_box">
        <div v-for="(item, index) in jobClassList" :key="index" @click="toSearch(item)">
            <img :src="item.imgUrl" :alt="item.nameText">
            <p>{{item.nameText}}</p>
        </div>
    </div>
    <div class="post_warp">
        <van-tabs v-model="active" animated line-width="40" line-height="2" color="#2E7FFF" title-inactive-color="#333" title-active-color="#2E7FFF">
            <van-tab title="急招岗位">
                <div class="post_list_box">
                    <div class="post_item_box" v-for="(item, index) in indexDatas.hotjoblist" :key="index"  @click="jobClick(item)">
                        <div class="job_info_box">
                            <van-tag style="margin-right: 0.2rem;" color="rgba(245,108,108,0.2)" text-color="#F56C6C">急招</van-tag>
                            <p>{{item.jobname}}</p>
                            <p>{{item.salarytext}}</p>
                        </div>
                        <p class="p_name_text">{{item.companydisplayname}}</p>
                        <div class="tags_box">
                            <div class="tags_div">
                                <p>{{item.jobplace}}</p>
                                <p>{{item.industryname}}</p>
                                <p>{{item.exptypename}}</p>
                            </div>
                            <p class="time_text">{{item.lastupdatetime}}</p>
                        </div>
                    </div>
                    <div @click="toPage('MTalentSearch')" class="see_more_box">查看更多></div>
                </div>
            </van-tab>
            <van-tab title="最新职位">
                <div class="post_list_box">
                    <div class="post_item_box" v-for="(item, index) in indexDatas.newjoblist" :key="index"  @click="jobClick(item)">
                        <div class="job_info_box">
                            <p class="p1">{{item.jobname}}</p>
                            <p>{{item.salarytext}}</p>
                        </div>
                        <p class="p_name_text">{{item.companydisplayname}}</p>
                        <div class="tags_box">
                            <div class="tags_div">
                                <p>{{item.jobplace}}</p>
                                <p>{{item.industryname}}</p>
                                <p>{{item.exptypename}}</p>
                            </div>
                            <p class="time_text">{{item.lastupdatetime}}</p>
                        </div>
                    </div>
                    <div @click="toPage('MTalentSearch')" class="see_more_box">查看更多></div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
    <div class="city_list_warp">
        <div class="title_box">热招城市</div>
        <div class="city_list_box">
            <div v-for="(item, index) in cityList" :key="index" @click="clickCityToSearch(item)">
                <img :src="item.imgUrl" :alt="item.nameText">
                <p>{{item.nameText}}</p>
            </div>
        </div>
    </div>
    <div class="hzqy_box">
        <div class="title_box">合作企业</div>
        <img :src="require('@/common/images/mtalentimgs/icon_hzqy.png')" alt="">
    </div>
</div>
</template>

<script>
import {getIndexInfo} from 'api/talent'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'mTalentIndexContent',
    data() {
        return {
            active: 0,
            jobClassList: [
                {
                    nameText: '董秘类',
                    code: '01',
                    imgUrl: require('@/common/images/mtalentimgs/icon_class1.png'),
                },
                {
                    nameText: '财务类',
                    code: '02',
                    imgUrl: require('@/common/images/mtalentimgs/icon_class2.png'),
                },
                {
                    nameText: '人力类',
                    code: '03',
                    imgUrl: require('@/common/images/mtalentimgs/icon_class3.png'),
                },
                {
                    nameText: '投资类',
                    code: '04',
                    imgUrl: require('@/common/images/mtalentimgs/icon_class4.png'),
                }
            ],
            cityList: [
                {
                    nameText: '北京',
                    code: 1,
                    imgUrl: require('@/common/images/mtalentimgs/icon_city1.png'),
                },
                {
                    nameText: '上海',
                    code: 2,
                    imgUrl: require('@/common/images/mtalentimgs/icon_city2.png'),
                },
                {
                    nameText: '广州',
                    code: 3,
                    imgUrl: require('@/common/images/mtalentimgs/icon_city3.png'),
                },
                {
                    nameText: '深圳',
                    code: 4,
                    imgUrl: require('@/common/images/mtalentimgs/icon_city4.png'),
                },
                {
                    nameText: '成都',
                    code: 5,
                    imgUrl: require('@/common/images/mtalentimgs/icon_city5.png'),
                },
                {
                    nameText: '杭州',
                    code: 6,
                    imgUrl: require('@/common/images/mtalentimgs/icon_city6.png'),
                },
                {
                    nameText: '苏州',
                    code: 7,
                    imgUrl: require('@/common/images/mtalentimgs/icon_city7.png'),
                },
                {
                    nameText: '东莞',
                    code: 8,
                    imgUrl: require('@/common/images/mtalentimgs/icon_city8.png'),
                },
                {
                    nameText: '佛山',
                    code: 9,
                    imgUrl: require('@/common/images/mtalentimgs/icon_city9.png'),
                },
                {
                    nameText: '武汉',
                    code: 10,
                    imgUrl: require('@/common/images/mtalentimgs/icon_city10.png'),
                }
            ],
            indexDatas: {
                rolllist: [],
                hotjoblist: [],
                newjoblist: []
            }
        }
    },
    mounted() {
        this.initIndexInfo()
    },
    methods: {
        initIndexInfo() {
            this.setLoading(true)
            getIndexInfo({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.indexDatas = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        jobClick(val) {
            this.$router.push({name: 'MJobInfo', query: {'jobid': val.jobinnerid}})
        },
        toSearch(val) {
            this.$router.push({name: 'MTalentSearch', query: {'key': '', 'jobtypecode01': val.code}})
        },
        clickCityToSearch(val) {
            this.$router.push({name: 'MTalentSearch', query: {'key': '', 'jobplace': val.code}})
        },
        toPage(val) {
            this.setRefresh(true)
            this.$router.push({name: val, query: {'key': ''}})
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.mTalentIndexContent {
    font-family:PingFangSC-Medium,PingFang SC;
    color:rgba(51,51,51,1);
    background-color: #F5F7FA;
    padding-bottom: 0.2rem;
    &>div {
        background-color: #FFF;
        .title_box {
            display: block;
            text-align: left;
            overflow: hidden;
            color: #2B5278;
            line-height: 0.4rem;
            font-size: 0.28rem;
            padding-bottom: 0.1rem;
            position: relative;
            font-weight: bold;
        }
        .title_box::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0.64rem;
            height: 0.04rem;
            background: transparent url(../../../../common/images/mtalentimgs/bg_line.png) left top no-repeat;
            background-size: 100%;
        }
    }
    .top_box {
        width: 100vw;
        height: 3.88rem;
        background: url('../../../../common/images/mtalentimgs/bg1.png') no-repeat center;
        background-size: 100% 100%;
        position: relative;
        padding: 0 0.32rem;
        padding-top: 1rem;
        box-sizing: border-box;
        &>h4 {
            color: #FFF;
            font-size: 0.48rem;
            font-weight: bold;
            line-height: 0.68rem;
            margin-bottom: 0.24rem;
        }
        &>p {
            color: #FFF;
            font-size: 0.28rem;
            line-height: 0.4rem;
        }
        .swiper_box {
            background:rgba(255,255,255,0.15);
            border-radius: 0.24rem;
            margin-top: 0.76rem;
            .van-swipe__indicators {
                display: none;
            }
            .van-swipe-item {
                display: flex;
                align-items: center;
                padding-left: 0.2rem;
                box-sizing: border-box;
                &>p {
                    line-height: 0.34rem;
                    font-size: 0.24rem;
                    color: #fff;
                }
                &>p:nth-of-type(2) {
                    color: #FF7F04;
                    margin: 0 0.32rem;
                }
                &>p:nth-of-type(3) {
                    width: 1.92rem;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                }
                &>p:nth-of-type(4) {
                    color: #5EBDFF;
                    margin-left: 0.24rem;
                    margin-right: 0.32rem;
                }
            }
        }
    }
    .job_class_box {
        padding: 0.32rem 0.65rem;
        display: flex;
        justify-content: space-between;
        &>div {
            img {
                width: 0.94rem;
                height: 0.94rem;
            }
            p {
                margin-top: 0.16rem;
                text-align: center;
                line-height: 0.32rem;
                font-size: 0.26rem;
            }
        }
    }
    .post_warp {
        margin-top: 0.2rem;
        .van-tab__text--ellipsis {
            font-weight: bold;
        }
        .post_list_box {
            padding: 0 0.32rem;
            .post_item_box {
                padding: 0.32rem 0;
                border-bottom: 0.01rem solid #E5E5E5;
                .job_info_box {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    &>p {
                        font-size:0.32rem;
                        width: 4rem;
                        font-weight: bold;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                    &>p:nth-of-type(2) {
                        width: 1.9rem;
                        color: #FF7F04;
                        text-align: right;
                    }
                    .p1 {
                        width: 4.3rem;
                    }
                }
                .p_name_text {
                    line-height: 0.4rem;
                    font-size: 0.28rem;
                    margin-top: 0.12rem;
                    margin-bottom: 0.2rem;
                    color: #999999;
                }
                .tags_box {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .tags_div {
                        display: flex;
                        &>p {
                            color: #5EBDFF;
                            border-radius: 0.04rem;
                            padding: 0 0.1rem;
                            height: 0.4rem;
                            line-height: 0.4rem;
                            text-align: center;
                            font-size: 0.24rem;
                            border: 0.02rem solid #5EBDFF;
                            max-width: 1.3rem;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                        }
                        p + p {
                            margin-left: 0.2rem;
                        }
                    }
                    .time_text {
                        line-height: 0.4rem;
                        font-size: 0.28rem;
                        color: #999999;
                    }
                }
            }
            .see_more_box {
                line-height: 0.88rem;
                color: #999;
                font-size: 0.24rem;
                text-align: center;
            }
        }
    }
    .city_list_warp {
        margin-top: 0.2rem;
        padding: 0.32rem;
        .city_list_box {
            display: flex;
            flex-wrap: wrap;
            &>div {
                margin-right: 0.54rem;
                margin-top: 0.32rem;
                img {
                    width: 0.94rem;
                    height: 0.94rem;
                }
                p {
                    margin-top: 0.16rem;
                    text-align: center;
                    line-height: 0.32rem;
                    font-size: 0.26rem;
                }
            }
            &>div:nth-of-type(5n) {
                margin-right: 0;
            }
        }
    }
    .hzqy_box {
        margin-top: 0.2rem;
        padding: 0.32rem;
        &>img {
            margin-top: 0.3rem;
            width: 100%;
        }
    }
}
</style>